(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("ui.bootstrap"), require("ng-idle"));
	else if(typeof define === 'function' && define.amd)
		define(["angular", "ui.bootstrap", "ng-idle"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("angular"), require("ui.bootstrap"), require("ng-idle")) : factory(root["angular"], root["ui.bootstrap"], root["ng-idle"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_43__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!*****************!*\
  !*** ./main.js ***!
  \*****************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./module */ 1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(MODULE_NAME) {
	    return MODULE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1 */
/*!*******************!*\
  !*** ./module.js ***!
  \*******************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! angular */ 2),
	    __webpack_require__(/*! ./ilmn-ui-nav/main */ 3),
	    __webpack_require__(/*! ./ilmn-ui-toolbar/main */ 11),
	    __webpack_require__(/*! ./ilmn-ui-comments/main */ 16),
	    __webpack_require__(/*! ./ilmn-ui-loading-animation/main */ 30),
	    __webpack_require__(/*! ./ilmn-ui-utils/main */ 18),
	    __webpack_require__(/*! ./ilmn-ui-alert-banner/main */ 36),
	    __webpack_require__(/*! ./ilmn-ui-idle/main */ 41),
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, IlmnUiNav, IlmnUiToolbar, IlmnUiComments, IlmnUiLoadingAnimations, IlmnUiUtils, IlmnUiAlertBanner, IlmnUiIdle) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-core';
	
	    return angular
	        .module(MODULE_NAME, [IlmnUiNav, IlmnUiToolbar, IlmnUiComments, IlmnUiUtils, IlmnUiLoadingAnimations, IlmnUiAlertBanner, IlmnUiIdle])
	        .name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/*!**************************!*\
  !*** external "angular" ***!
  \**************************/
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/*!*****************************!*\
  !*** ./ilmn-ui-nav/main.js ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 4),
	
	    __webpack_require__(/*! ./scripts/nav.directive */ 7),
	    __webpack_require__(/*! ./scripts/appSwitcher.directive */ 8)
	
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(module_name) {
	    return module_name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/*!*******************************!*\
  !*** ./ilmn-ui-nav/module.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../ilmn-ui-utils/module */ 5), __webpack_require__(/*! ui.bootstrap */ 6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, ilmnUiUtils) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-nav';
	
	    return angular
	        .module(MODULE_NAME, [ilmnUiUtils, 'ui.bootstrap'])
	        .config(['$httpProvider', 'ilmnUiCookieUtilProvider', ModuleConfig])
	        .run(['$log', ModuleRun])
	        .name;
	
	    function ModuleConfig($httpProvider,ilmnUiCookieUtilProvider) {
	
	        var psToken = ilmnUiCookieUtilProvider.get('psToken');
	
	        var interceptor = ['$rootScope', '$q', function ($rootScope, $q) {
	            return {
	                request: function (config) {
	                    // if ((config.url.indexOf('platform-services') === 0)) {
	                    //     config.headers.Authorization = 'Bearer '+ psToken
	                    // }
	                    config.headers.Authorization = 'Bearer '+ psToken;
	                    return config;
	                },
	                response: function (response) {
	                    return response;
	                },
	                responseError: function (response) {
	                    return $q.reject(response);
	                }
	            }
	        }];
	        $httpProvider.interceptors.push(interceptor);
	
	    }
	
	    function ModuleRun($log) {
	        $log.info('Started nav module.');
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 5 */
/*!*********************************!*\
  !*** ./ilmn-ui-utils/module.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ui.bootstrap */ 6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-utils';
	
	    return angular
	        .module(MODULE_NAME, ['ui.bootstrap'])
	        .name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 6 */
/*!*******************************!*\
  !*** external "ui.bootstrap" ***!
  \*******************************/
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/*!**********************************************!*\
  !*** ./ilmn-ui-nav/scripts/nav.directive.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    angular.module(MODULE_NAME)
	        .directive('ilmnUiNav', UiNavDirective);
	
	    UiNavDirective.$inject = ['$rootScope'];
	    function UiNavDirective($rootScope) {
	        return {
	            restrict: 'A',
	            link: function(scope,elem) {
	                var menuItemWidth;
	                var marker = $('<li class="hidden-xs marker"></li>');
	
	                elem.append(marker);
	
	                $rootScope.$on('$stateChangeSuccess', function() {
	                    $rootScope.$applyAsync(function() {
	                        slideToActive(marker, elem);
	                    })
	                });
	
	                elem.find('.navbar-menu-item')
	                    .on('mouseover', function() { pingPongAnimation(marker, this); })
	                    .on('mouseout', function() { slideToActive(marker, elem); })
	
	
	                ////////////
	
	                function pingPongAnimation(marker, menuItem) {
	                    if(typeof menuItem === 'undefined') {
	                        marker.css({opacity: 0})
	                    }
	                    else {
	                        menuItemWidth =  $(menuItem).width();
	
	                        marker.css({
	                            opacity: 0.35,
	                            left: $(menuItem).position().left + "px",
	                            width: $(menuItem).width() + "px"
	                        });
	                    }
	
	                }
	
	                function slideToActive(marker, listId) {
	                    var list = $(listId);
	                    var hasActive = false;
	                    var childItems = list.children(':visible');
	
	                    if(childItems.length) {
	                        for(var i = 0; i < (childItems.length - 1); i++) {
	                            if( $(childItems[i]).hasClass("active") ){
	                                pingPongAnimation(marker, childItems[i]);
	                                hasActive = true;
	                                $(childItems[i]).css("width", menuItemWidth + "px");
	                            } else {
	                                $(childItems[i]).css("width", "initial");
	                            }
	                        }
	                        if(!hasActive) {
	                            pingPongAnimation(marker);
	                        }
	                    }
	                }
	            }
	        }
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))


/***/ }),
/* 8 */
/*!******************************************************!*\
  !*** ./ilmn-ui-nav/scripts/appSwitcher.directive.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	
	    var templateUrl = __webpack_require__(/*! ../views/appSwitcher.template.html */ 9);
	    var mobileTemplateUrl = __webpack_require__(/*! ../views/mobileAppSwitcher.template.html */ 10);
	    angular.module(MODULE_NAME)
	        .directive('ilmnUiAppSwitcher', function() {
	            return {
	                scope: {
	                    appName: '@',
	                    dropdownCollapsed: '='
	                },
	                replace: true, //We have to do this because the CSS is too specific
	                controller: UiAppSwitcherController,
	                controllerAs: 'vm',
	                bindToController: true,
	                templateUrl: function ($element, $attrs) {
	                    if($attrs.mobileView) {
	                        return mobileTemplateUrl;
	                    }
	                    return templateUrl;
	                }
	            }
	        });
	
	    UiAppSwitcherController.$inject = ['PlatformDomainService', '$location', '$log'];
	
	    function UiAppSwitcherController(platformDomainService, $location, $log) {
	
	        var vm = this;
	
	        vm.$onInit = function() {
	            vm.appList = [];
	
	            vm.appLabel = vm.appName.replace(/[\s,]+/g, '<br />');
	            vm.platformHost = platformDomainService.getPlatformServiceUrl(true);
	            vm.domainName = platformDomainService.getCurrentDomain();
	
	            collectAppList();
	        }
	
	        //////////
	
	        function collectAppList() {
	            if(!vm.platformHost) {
	                return;
	            }
	
	            var url = vm.platformHost + '/do/globalAdmin/domainApp/search?domain={domainName}';
	
	            platformDomainService.getDomainInfo(vm.domainName, url).then(function(domainInfo) {
	                if (domainInfo) {
	
	                    // TODO
	                    // Show Workgroup Admin console only for public domain.
	                    // Show workgroup admin console for user who are admins for the current workgroup
	
	                    if (domainInfo.list && angular.isArray(domainInfo.list)) {
	                        domainInfo.list.forEach(function(app) {
	                            var url;
	
	                            // show only provisioned apps in the dropdown
	                            if (app.globalAppTO.allowedToProvision) {
	
	                                if(domainInfo.isPublicDomain) {
	                                    url = app.globalAppTO.publicUrl || app.globalAppTO.app_url;
	                                }
	                                else {
	                                    url = app.globalAppTO.app_url;
	                                    url = url.replace(app.globalAppTO.url_pattern, vm.domainName);
	                                }
	                                vm.appList.push({
	                                    name: app.globalAppTO.name.replace(/[\s,]+/g, '<br />'),
	                                    url: url,
	                                    label: app.globalAppTO.description,
	                                    class: app.globalAppTO.appColor || 'dflt'
	                                });
	                            }
	                        });
	                    }
	                }
	            });
	        }
	
	        vm.toggleCollapsed = function() {
	            vm.dropdownCollapsed = !vm.dropdownCollapsed;
	        }
	
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))


/***/ }),
/* 9 */
/*!*****************************************************!*\
  !*** ./ilmn-ui-nav/views/appSwitcher.template.html ***!
  \*****************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/appSwitcher.template.html';
	var html = "<div> <a class=\"navbar-brand desktop tablet\" ui-sref=user-gateway() href=/user-gateway>BaseSpace</a> <ul class=\"nav navbar-nav product-dropdown desktop tablet\"> <li class=dropdown uib-dropdown> <a class=\"dropdown-toggle product-button\" uib-dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false> <span class=product-name> <span data-ng-bind-html=vm.appLabel></span> <span class=\"fa fa-angle-down fa-lg\" ng-if=vm.appList.length></span> </span> </a> <ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-left product-links\"> <li class=product-item data-ng-class=link.class ng-repeat=\"link in vm.appList\" ng-if=vm.appList.length> <a href=\"{{ link.url }}\"><span class=product-name data-ng-bind-html=link.name></span></a> </li> </ul> </li> </ul> </div> ";
	window.angular.module('ilmn-ui-nav').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 10 */
/*!***********************************************************!*\
  !*** ./ilmn-ui-nav/views/mobileAppSwitcher.template.html ***!
  \***********************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/mobileAppSwitcher.template.html';
	var html = "<li class=responsive-app-chooser> <div class=panel> <div class=panel-heading> <a disable-auto-close ng-click=vm.toggleCollapsed() class=collapsed href=#app-chooser-menu-mobile data-toggle=collapse data-parent=#accordion> <span>BaseSpace</span> <span class=\"fa fa-caret-down pull-right\" ng-if=vm.appList.length></span> </a> </div> <div uib-collapse=vm.dropdownCollapsed id=app-chooser-menu-mobile class=\"panel-collapse collapse\" ng-if=vm.appList.length> <div class=panel-body> <ul class=\"responsive-app-chooser-dropdown product-links\"> <li class=product-item ng-class=link.class ng-repeat=\"link in vm.appList\"> <a href=\"{{ link.url }}\" target=_blank nb-click-track=navbar><span class=product-name data-ng-bind-html=link.name></span></a> </li> </ul> </div> </div> </div> </li> ";
	window.angular.module('ilmn-ui-nav').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 11 */
/*!*********************************!*\
  !*** ./ilmn-ui-toolbar/main.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 12),
	
	    __webpack_require__(/*! ./scripts/toolbar.directive */ 13),
	    __webpack_require__(/*! ./scripts/toolbarOptions.provider */ 14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(module_name) {
	    return module_name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 12 */
/*!***********************************!*\
  !*** ./ilmn-ui-toolbar/module.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-toolbar';
	
	    return angular
	        .module(MODULE_NAME, [])
	        .name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 13 */
/*!******************************************************!*\
  !*** ./ilmn-ui-toolbar/scripts/toolbar.directive.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 12), __webpack_require__(/*! ./toolbarOptions.provider */ 14)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME, UiToolbarOptions) {
	    'use strict';
	
	    var templateUrl = __webpack_require__(/*! ../views/toolbar.template.html */ 15);
	    angular.module(MODULE_NAME)
	        .directive('ilmnUiToolbar', UiToolbarDirective);
	
	    function UiToolbarDirective() {
	        return {
	            restrict: 'EA',
	            controller: UiToolbarController,
	            controllerAs: 'vm',
	            templateUrl: templateUrl,
	            bindToController: true,
	            scope: {
	                options: '='
	            }
	        }
	    }
	
	    UiToolbarController.$inject = [UiToolbarOptions];
	    function UiToolbarController(UiToolbarOptions) {
	        var vm = this;
	
	        if(vm.options && !(vm.options instanceof UiToolbarController)) {
	            vm.options = new UiToolbarOptions(vm.options.options || []);
	        }
	
	        vm.optionClicked = function(option) {
	            if(option.action) {
	                option.action.call(option);
	            }
	        }
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 14 */
/*!************************************************************!*\
  !*** ./ilmn-ui-toolbar/scripts/toolbarOptions.provider.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 12)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var PROVIDER_NAME = 'ilmnUiToolbarOptionsProvider';
	
	    angular.module(MODULE_NAME)
	        .provider(PROVIDER_NAME, UiToolbarOptionsProvider);
	
	    function UiToolbarOptionsProvider() {
	        this.$get = function() {
	            return UiToolbarOptions;
	        }
	    }
	
	    function UiToolbarOptions(options) {
	        this.options = options;
	    }
	
	    UiToolbarOptions.prototype = {
	        findOption: function(options, label) {
	            var match, self = this;
	
	            options.some(function(option) {
	                if(option.label === label) {
	                    match = option;
	                }
	                else if(option.subOptions) {
	                    match = self.findOption.call(self, option.subOptions, label);
	                }
	                return !!match;
	            });
	
	            return match;
	        },
	        updateOption: function(optionLabel, updateFn) {
	            var option = this.findOption(this.options, optionLabel);
	            if(option) {
	                updateFn(option);
	            }
	        },
	        addOption: function(option) {
	            this.options.push(option);
	        },
	
	        setAction: function(optionLabel, action) {
	            this.updateOption(optionLabel, function(option) {
	                option.action = action;
	            })
	        },
	
	        hideOption: function(optionLabel) {
	            this.updateOption(optionLabel, function(option) {
	                option.hidden = true;
	            })
	        },
	        showOption: function(optionLabel) {
	            this.updateOption(optionLabel, function(option) {
	                option.hidden = false;
	            })
	        },
	
	        disableOption: function(optionLabel) {
	            this.updateOption(optionLabel, function(option) {
	                option.disabled = true;
	            })
	        },
	        enableOption: function(optionLabel) {
	            this.updateOption(optionLabel, function(option) {
	                option.disabled = false;
	            })
	        },
	        toggleOption: function(optionLabel) {
	            this.updateOption(optionLabel, function(option) {
	                option.disabled = !option.disabled;
	            })
	        }
	    };
	
	    return PROVIDER_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 15 */
/*!*****************************************************!*\
  !*** ./ilmn-ui-toolbar/views/toolbar.template.html ***!
  \*****************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/toolbar.template.html';
	var html = "<div class=\"toolbar-main navbar-nav navbar-right\"> <div style=display:inline ng-repeat=\"option in vm.options.options\"> <a type=button class=\"btn btn-icon\" ng-if=!option.subOptions ng-attr-nb-feature-switch={{option.featureSwitch}} nb-click-track=toolbar ng-click=vm.optionClicked(option) ng-disabled=option.disabled ng-hide=option.hidden> <span class=\"icon fa fa-lg\" ng-class=option.icon></span><br/> {{option.label}} </a> <div uib-dropdown class=\"dropdown icon inline\" style=vertical-align:auto ng-if=option.subOptions ng-hide=option.hidden> <a uib-dropdown-toggle class=\"btn btn-icon\" ng-disabled=option.disabled ng-click=vm.optionClicked(option)> <span class=\"icon fa fa-lg\" ng-class=option.icon></span><br/> {{option.label}} <span class=\"fa fa-angle-down\"></span> </a> <ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\"> <li ng-repeat=\"suboption in option.subOptions\" ng-attr-nb-feature-switch={{suboption.featureSwitch}} ng-class=\"{divider: suboption.type == 'divider', disabled: suboption.disabled}\" ng-hide=suboption.hidden> <a ng-if=\"suboption.type == 'loading'\"> <ilmn-ui-inline-loading-animation></ilmn-ui-inline-loading-animation> </a> <a ng-if=!suboption.type href=\"{{suboption.href || '#'}}\" ng-click=vm.optionClicked(suboption) nb-click-track=toolbar>{{suboption.label}}</a> </li> </ul> </div> </div> </div> ";
	window.angular.module('ilmn-ui-toolbar').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 16 */
/*!**********************************!*\
  !*** ./ilmn-ui-comments/main.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 17),
	
	    __webpack_require__(/*! ./scripts/commentsModal.service */ 23)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(MODULE_NAME){
	   return MODULE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 17 */
/*!************************************!*\
  !*** ./ilmn-ui-comments/module.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../ilmn-ui-utils/main */ 18), __webpack_require__(/*! ui.bootstrap */ 6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, IlmnUiUtils) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-comments';
	
	    return angular
	        .module(MODULE_NAME, ['ui.bootstrap', IlmnUiUtils])
	        .name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 18 */
/*!*******************************!*\
  !*** ./ilmn-ui-utils/main.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 5),
	
	    __webpack_require__(/*! ./scripts/confirmDialog.service */ 19),
	    __webpack_require__(/*! ./scripts/cookie.provider */ 21),
	    __webpack_require__(/*! ./services/platformDomain.service */ 22)
	
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(module_name) {
	    return module_name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 19 */
/*!********************************************************!*\
  !*** ./ilmn-ui-utils/scripts/confirmDialog.service.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var SERVICE_NAME = 'ilmnUiConfirmDialogService';
	    var templateUrl = __webpack_require__(/*! ../views/configDialog.template.html */ 20);
	    
	    angular.module(MODULE_NAME)
	        .service(SERVICE_NAME, ConfirmModalService);
	
	    ConfirmModalService.$inject = ['$uibModal'];
	    function ConfirmModalService($uibModal) {
	        var modalDefaults = {
	            backdrop: true,
	            keyboard: true,
	            modalFade: true,
	            size: 'sm',
	            templateUrl: templateUrl
	        };
	
	        var viewOptions = {
	            closeButtonText: 'Close',
	            actionButtonText: 'OK',
	            message: 'Perform this action?'
	        };
	
	        this.show = function (customModalDefaults, customViewOptions) {
	            //Create temp objects to work with since we're in a singleton service
	            var tempModalDefaults = {};
	            var tempViewOptions = {};
	
	            //Map angular-ui modal custom defaults to modal defaults defined in service
	            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
	
	            //Map modal.html $scope custom properties to defaults defined in service
	            angular.extend(tempViewOptions, viewOptions, customViewOptions);
	
	            if (!tempModalDefaults.controller) {
	                tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	                    $scope.modalOptions = tempViewOptions;
	                    $scope.modalOptions.ok = function (result) {
	                        $uibModalInstance.close(result);
	                    };
	                    $scope.modalOptions.close = function () {
	                        $uibModalInstance.dismiss('cancel');
	                    };
	                }];
	            }
	
	            return $uibModal.open(tempModalDefaults).result;
	        };
	    }
	
	    return SERVICE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 20 */
/*!********************************************************!*\
  !*** ./ilmn-ui-utils/views/configDialog.template.html ***!
  \********************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/configDialog.template.html';
	var html = "<div class=\"modal-body row\"> <p>{{modalOptions.message}}</p> <div class=\"form-group pull-right\"> <button type=button class=btn data-ng-click=modalOptions.close()>{{modalOptions.closeButtonText}}</button> <button class=\"btn btn-primary\" data-ng-click=modalOptions.ok();>{{modalOptions.actionButtonText}}</button> </div> </div> ";
	window.angular.module('ilmn-ui-utils').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 21 */
/*!**************************************************!*\
  !*** ./ilmn-ui-utils/scripts/cookie.provider.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var SERVICE_NAME = 'ilmnUiCookieUtil';
	
	    angular.module(MODULE_NAME)
	        .provider(SERVICE_NAME, CookieUtil);
	
	    function CookieUtil() {
	
	    }
	    CookieUtil.prototype = {
	        $get: ['$cookies', function($cookies) {
	            return $cookies;
	        }],
	        get : function (cname) {
	            var name = cname + "=";
	            var ca = document.cookie.split(';');
	            for(var i = 0; i <ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0)==' ') {
	                    c = c.substring(1);
	                }
	                if (c.indexOf(name) == 0) {
	                    return c.substring(name.length,c.length);
	                }
	            }
	            return "";
	        },
	
	        set: function (cname, cvalue, exdays) {
	            var d = new Date();
	            d.setTime(d.getTime() + (exdays*24*60*60*1000));
	            var expires = "expires="+d.toUTCString();
	            document.cookie = cname + "=" + cvalue + "; " + expires;
	        }
	    };
	
	    return SERVICE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 22 */
/*!**********************************************************!*\
  !*** ./ilmn-ui-utils/services/platformDomain.service.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, MODULE_NAME ) {
	    'use strict';
	
	    angular
	        .module(MODULE_NAME)
	        .service('PlatformDomainService', PlaformDomainService);
	
	    PlaformDomainService.$inject = ['$http', '$log', '$location', 'ilmnUiCookieUtil'];
	    function PlaformDomainService($http, $log, $location, ilmnUiCookieUtil) {
	
	        var domainInfo;
	
	        return {
	            getCurrentDomain: getCurrentDomain,
	            getDomainInfo: getDomainInfo,
	            getPlatformServiceUrl: getPlatformServiceUrl
	        };
	
	        function getCurrentDomain() {
	            return $location.host().split('.')[0];
	        }
	
	        function getPlatformServiceUrl(domainSpecific) {
	            var psTokenIssuingAuthorities = ilmnUiCookieUtil.get('psTokenIssuingAuthorities');
	
	            if(psTokenIssuingAuthorities) {
	                var platformHost = psTokenIssuingAuthorities.replace(new RegExp('"', 'g'), '');
	                if(domainSpecific) {
	                    platformHost = platformHost.replace(/https:\/\//, 'https://' + getCurrentDomain() + ".");
	                }
	                return platformHost;
	            }
	        }
	
	        function getDomainInfo(subDomain, platformDomainInfoUrl) {
	            if (!domainInfo) {
	                var regex = new RegExp("{domainName}", 'g');
	                var url = platformDomainInfoUrl.replace(regex, subDomain);
	                domainInfo = $http.get(url).then(
	                    function successCallback(response) {
	                        updateUrlsForApps(response.data);
	                        return response.data;
	                    },
	                    function errorCallback(response) {
	                        $log.error('There was error getting domain info: ', response);
	                    }
	                );
	            }
	            return domainInfo;
	        }
	
	        function updateUrlsForApps(domainInfo) {
	            if (domainInfo.apps && domainInfo.apps.length > 0) {
	                domainInfo.apps.forEach(function(app) {
	                    var subDomain = domainInfo.urlPatterns && domainInfo.urlPatterns.length > 0 ? domainInfo.urlPatterns[0] : undefined;
	                    if (subDomain && app.urlPattern && app.appUrl && app.appUrl.indexOf(app.urlPattern) !== -1) {
	                        app.appUrl = app.appUrl.replace(app.urlPattern, subDomain);
	                    }
	                });
	            }
	        }
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 23 */
/*!***********************************************************!*\
  !*** ./ilmn-ui-comments/scripts/commentsModal.service.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 17), __webpack_require__(/*! ./commentsModal.controller */ 24)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME, CommentsModalController) {
	    'use strict';
	
	   var SERVICE_NAME = 'ilmnUiCommentsModalService';
	   var templateUrl = __webpack_require__(/*! ../views/commentsDialog.template.html */ 25);
	   var styles = __webpack_require__(/*! ./commentsModal.styles.less */ 26);
	
	    angular.module(MODULE_NAME)
	        .service(SERVICE_NAME, CommentsModalService);
	
	    CommentsModalService.$inject = ['$uibModal'];
	    function CommentsModalService($uibModal) {
	        return {
	            open: function (options) {
	                return $uibModal.open({
	                    templateUrl: templateUrl,
	                    controller: CommentsModalController,
	                    controllerAs: 'vm',
	                    bindToController: true,
	                    backdrop: true,
	                    keyboard: false,
	                    modalFade: true,
	                    size: 'xl',
	                    windowClass: 'ilmn-modal-double-panel',
	                    resolve: {
	                        options: function() {
	                            return options;
	                        }
	                    }
	                });
	            }
	        }
	    }
	
	    return SERVICE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 24 */
/*!**************************************************************!*\
  !*** ./ilmn-ui-comments/scripts/commentsModal.controller.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 17)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var $ = angular.element,
	        CONTROLLER_NAME = 'IlmnUiCommentsModalCtrl';
	
	    angular.module(MODULE_NAME)
	        .controller(CONTROLLER_NAME, IlmnUiCommentsModalCtrl);
	
	    IlmnUiCommentsModalCtrl.$inject = ['$q', '$timeout', '$uibModalInstance', 'ilmnUiConfirmDialogService', 'options', '$uibModalStack', '$ilmnUiAlertBannerService'];
	    function IlmnUiCommentsModalCtrl($q, $timeout, $modalInstance, confirmDialogSvc, options, $uibModalStack, $ilmnUiAlertBannerService) {
	        var vm = this,
	            animationTiming = 250;
	
	        var defaults = {
	            comments: [],
	            add: noop,
	            edit: noop,
	            delete: noop,
	            maxLength: 1024
	        };
	
	        $timeout(function(){
	            $ilmnUiAlertBannerService.show({
	                message: "Direct identifiers should not be stored in custom fields",
	                overlay: false,
	                prependTo: '.modal',
	                type: 'notify',
	                dismissible: true
	            });
	        });
	
	        angular.extend(vm, defaults, options);
	
	        vm.close = close;
	        vm.cancel = cancel;
	        vm.saveComment = saveComment;
	        vm.selectComment = selectComment;
	        vm.deleteComment = deleteComment;
	
	        init();
	
	        //////////////////////////////////
	
	        function init() {
	            resetForm();
	        }
	
	        function selectComment(comment, $event) {
	            vm.selectedComment = comment;
	            vm.editableComment = comment.comments;
	            animateEditSelection($event);
	        }
	
	        function close() {
	            $uibModalStack.dismissAll();
	        }
	
	        function cancel(evt) {
	            if(vm.commentsForm.$dirty) {
	                return confirmDialogSvc.show({
	                    appendTo: $(evt.currentTarget).parent()
	                }, {
	                    message: 'Do you want to cancel edits to this comment?'
	                }).then(resetForm);
	            }
	
	            if (vm.commentsForm.$pristine && !vm.editableComment){
	                close();
	            }
	
	            resetForm();
	        }
	
	        function saveComment() {
	            if(vm.selectedComment.id) {
	                editComment(vm.selectedComment);
	            }
	            else {
	                addComment({ comments: vm.editableComment });
	            }
	        }
	
	        function addComment(comment) {
	            vm.add(comment)
	                .then(function(item) {
	                    vm.comments.unshift(item);
	                    resetForm();
	
	                    $timeout(function() {
	                        animateComment(item);
	                    }, 10);
	                }, showApiErrorBanner);
	        }
	
	        function deleteComment(comment, index, $event) {
	            var dialog = confirmDialogSvc.show({
	                appendTo: $($event.currentTarget).parent().parent()
	            }, {
	                message: 'Delete this comment? Proceeding will not delete any associated events.'
	            });
	            dialog.backdrop = false;
	            dialog.then(function() {
	                vm.updatingComment = comment.id;
	
	                vm.delete(comment)
	                    .then(function() {
	                        vm.comments.splice(index, 1);
	                        delete vm.updatingComment;
	                    }, showApiErrorBanner);
	            });
	        }
	
	        function showApiErrorBanner(resp) {
	            delete vm.updatingComment;
	            vm.serviceError = true;
	
	            $ilmnUiAlertBannerService.show({
	                message: resp.data || "Comments service is unavailable.",
	                overlay: false,
	                prependTo: '.modal-content',
	                type: 'danger'
	            });
	        }
	
	        function resetForm() {
	            vm.selectedComment = {};
	            vm.editableComment = '';
	            vm.commentsForm && vm.commentsForm.$setPristine();
	        }
	
	        function editComment(comment) {
	            var updatedComment = angular.extend({}, comment, {comments: vm.editableComment});
	            vm.updatingComment = comment.id;
	
	            vm.edit(updatedComment)
	                .then(function(updates) {
	                    delete vm.updatingComment;
	
	                    angular.extend(comment, updates);
	                    animateComment(comment);
	                    resetForm();
	                    // Commit changes to the UI
	                }, showApiErrorBanner);
	        }
	
	        function animateComment(comment) {
	            comment.class = 'new-row';
	            $timeout(function() {
	                delete comment.class;
	            }, 2500);
	        }
	
	        function animateEditSelection(evt) {
	
	            var eventTarget     = $(evt.currentTarget),
	                editingRow      = eventTarget.parents('tr'),
	                modalDiv        = eventTarget.parents('div.modal-dialog'),
	                allRows         = modalDiv.find('tbody tr'),
	
	                rowPosition     = 0,
	                rowHeight       = Math.round(editingRow.height()),
	                viewPortHeight  = Math.round(modalDiv.find('tbody').height()),
	                scrollDistance;
	
	            // Set row to editing
	            editingRow.toggleClass('editing');
	
	            // Calculate height of rows up till the editing row
	            $.each(allRows, function () {
	                if (!$(this).hasClass('editing')) {
	                    rowPosition += $(this).height();
	                } else {
	                    return false;
	                }
	            });
	
	            if (rowPosition === 0) {
	                scrollDistance = 0;
	            } else {
	                scrollDistance = (rowPosition + (rowHeight / 2)) - (viewPortHeight / 2);
	            }
	
	            // Scroll to position of row being edited
	            modalDiv.find('.modal-comments-table tbody').animate({
	                scrollTop: scrollDistance
	            }, animationTiming);
	        }
	
	        function noop(item) {
	            return $q.resolve(item);
	        }
	
	    }
	
	    return CONTROLLER_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 25 */
/*!*************************************************************!*\
  !*** ./ilmn-ui-comments/views/commentsDialog.template.html ***!
  \*************************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/commentsDialog.template.html';
	var html = "<div> <button type=button class=\"close fa fa-close\" data-dismiss=modal ng-click=vm.close()></button> <div class=comment-list> <h4 class=modal-title>Comments</h4> <table class=modal-comments-table> <thead> <tr> <th class=user-comment-meta>User</th> <th class=user-comment>Comment</th> </tr> </thead> <tbody> <tr data-ng-repeat=\"comment in vm.comments track by $index\" class=comments-row ng-class=\"[comment.class, {'editing': comment == vm.selectedComment, 'updating': comment.id == vm.updatingComment}]\"> <td class=user-comment-meta> <p>{{ comment.userName }} <span class=single-line>{{comment.createdDate | date}}</span> <span class=\"single-line edited-timestamp\" data-ng-if=\"comment.createdDate !== comment.modifiedDate\"> Edited: {{comment.modifiedDate | date}} </span> </p> </td> <td class=user-comment> <div class=comment-functions> <button class=edit-comment data-ng-click=\"vm.selectComment(comment, $event)\" data-ng-disabled=vm.selectedComment.createdDate data-ng-if=\"!comment.nonEditable && !vm.serviceError\"> <span class=\"fa fa-pencil\"></span> </button> <div class=\"ilmn-tooltip2 delete-confirmation ilmn-modal-double-panel__delete-tooltip\" tabindex=-1> <button class=\"delete-comment tooltip-trigger\" data-placement=ne-alt role=button data-toggle=modal data-ng-click=\"vm.deleteComment(comment, $index, $event)\" data-ng-disabled=vm.selectedComment.createdDate data-ng-if=\"!comment.nonEditable && !vm.serviceError\"> <span class=\"fa fa-trash\"></span> </button> </div> </div> <p class=comment-content data-ng-bind=comment.comments></p> <ilmn-ui-helix-loading-animation ng-if=\"vm.updatingComment == comment.id\"></ilmn-ui-helix-loading-animation> </td> </tr> </tbody> </table> </div> <div class=comment-form data-ng-form=vm.commentsForm> <h5 class=form-title> {{ vm.selectedComment.createdDate? 'Edit': 'New' }} comment <span class=characters-left>(<span class=characters-left-count>{{ vm.maxLength - vm.editableComment.length }}</span> characters left)</span> </h5> <form class=form> <div class=arrow-indicator data-ng-class=\"{edit: vm.selectedComment.createdDate}\"></div> <textarea class=comment-block maxlength=1024 data-ng-model=vm.editableComment></textarea> <div class=\"form-group comment-buttons\"> <button class=\"btn btn-default cancel-button\" data-ng-click=vm.cancel($event)>Cancel</button> <button class=\"btn btn-primary save-button\" data-ng-click=vm.saveComment() data-ng-disabled=\"vm.editableComment.length < 1\">Save</button> </div> </form> </div> </div> ";
	window.angular.module('ilmn-ui-comments').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 26 */
/*!************************************************************!*\
  !*** ./ilmn-ui-comments/scripts/commentsModal.styles.less ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !../../../~/css-loader!../../../~/less-loader!./commentsModal.styles.less */ 27);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./commentsModal.styles.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./commentsModal.styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 27 */
/*!*********************************************************************************************!*\
  !*** ../~/css-loader!../~/less-loader!./ilmn-ui-comments/scripts/commentsModal.styles.less ***!
  \*********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, ".comments-row{transition:opacity .3s ease-out}.comments-row.ng-leave,.comments-row.ng-leave-active{opacity:0}.comments-row.updating .comment-content,.comments-row.updating .comment-functions,.comments-row.updating .user-comment-meta{opacity:0!important}", ""]);
	
	// exports


/***/ }),
/* 28 */
/*!***************************************!*\
  !*** ../~/css-loader/lib/css-base.js ***!
  \***************************************/
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 29 */
/*!**************************************!*\
  !*** ../~/style-loader/addStyles.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 30 */
/*!*******************************************!*\
  !*** ./ilmn-ui-loading-animation/main.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 31),
	
	    __webpack_require__(/*! ./scripts/helix.component */ 32),
	    __webpack_require__(/*! ./scripts/inline.component */ 34)
	
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(module_name) {
	    return module_name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 31 */
/*!*********************************************!*\
  !*** ./ilmn-ui-loading-animation/module.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-loading-animation';
	
	    return angular
	        .module(MODULE_NAME, [])
	        .name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 32 */
/*!**************************************************************!*\
  !*** ./ilmn-ui-loading-animation/scripts/helix.component.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 31)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var templateUrl = __webpack_require__(/*! ../views/helix.template.html */ 33);
	    angular.module(MODULE_NAME)
	        .component('ilmnUiHelixLoadingAnimation', {
	            templateUrl: templateUrl
	        });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 33 */
/*!*************************************************************!*\
  !*** ./ilmn-ui-loading-animation/views/helix.template.html ***!
  \*************************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/helix.template.html';
	var html = "<div class=loader-position> <div class=loader-user-feedback> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> <span class=dots></span> </div> </div> ";
	window.angular.module('ilmn-ui-loading-animation').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 34 */
/*!***************************************************************!*\
  !*** ./ilmn-ui-loading-animation/scripts/inline.component.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 31)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var templateUrl = __webpack_require__(/*! ../views/inline.template.html */ 35);
	    angular.module(MODULE_NAME)
	        .component('ilmnUiInlineLoadingAnimation', {
	            templateUrl: templateUrl
	        });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 35 */
/*!**************************************************************!*\
  !*** ./ilmn-ui-loading-animation/views/inline.template.html ***!
  \**************************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/inline.template.html';
	var html = "<div class=loading-animation-wrapper> <div class=loading-animation-container> <span class=loading-animation-viewport> <span class=loading-animation-bar></span> </span> </div> </div> ";
	window.angular.module('ilmn-ui-loading-animation').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 36 */
/*!**************************************!*\
  !*** ./ilmn-ui-alert-banner/main.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 37),
	
	    __webpack_require__(/*! ./scripts/alertBanner.directive */ 38),
	    __webpack_require__(/*! ./scripts/alertBanner.service */ 40)
	
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(module_name) {
	    return module_name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 37 */
/*!****************************************!*\
  !*** ./ilmn-ui-alert-banner/module.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-alert-banner';
	
	    return angular
	        .module(MODULE_NAME, [])
	        .name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 38 */
/*!***************************************************************!*\
  !*** ./ilmn-ui-alert-banner/scripts/alertBanner.directive.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var templateUrl = __webpack_require__(/*! ../views/alertBanner.template.html */ 39);
	
	    angular.module(MODULE_NAME)
	        .directive('ilmnUiAlertBanner', function() {
	            return {
	                controller: UiAlertBannerController,
	                controllerAs: 'vm',
	                templateUrl: templateUrl,
	                scope: false,
	                bindToController: {
	                    options: '=',
	                    close: '&'
	                }
	            }
	        });
	
	    UiAlertBannerController.$inject = [];
	    function UiAlertBannerController() {
	        var vm = this;
	        var defaults = {
	            type: 'warning',
	            iconShow: true
	        };
	
	        var Icons = {
	            success: 'fa-check-circle',
	            info: 'fa-info-circle',
	            warning: 'fa-exclamation-circle',
	            danger: 'fa-exclamation-circle',
	            default: 'fa-info-circle',
	            notify: 'fa-exclamation-circle'
	        };
	
	        vm.options = angular.extend({}, defaults, vm.options);
	        vm.iconClass = Icons[vm.options.type];
	        vm.bannerClass = 'ilmn-alert-banner--'+vm.options.type + ' ' + vm.options.class;
	
	        if(vm.options.dismissible) {
	            vm.bannerClass += ' ilmn-alert-banner--dismissible';
	        }
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 39 */
/*!**************************************************************!*\
  !*** ./ilmn-ui-alert-banner/views/alertBanner.template.html ***!
  \**************************************************************/
/***/ (function(module, exports) {

	var path = 'ilmn-ui-components/dist/alertBanner.template.html';
	var html = "<div class=\"clearfix alert ilmn-alert-banner ilmn-alert-banner--has-buttons\" data-ng-class=\"(vm.bannerClass) + ' ' + (vm.options.buttons.length === 2 ? 'ilmn-alert-banner--2-buttons' : '')\"> <p ng-class=\"vm.options.iconShow ? '': 'no-icon'\"> <span class=\"ilmn-alert-banner__icon fa\" data-ng-class=vm.iconClass ng-show=vm.options.iconShow> </span> <span ng-class=\"vm.options.secondaryMessage ? 'primary-message' : ''\" ng-bind-html=vm.options.message></span> <span ng-if=vm.options.secondaryMessage class=secondary-message ng-bind-html=vm.options.secondaryMessage></span> </p> <div class=ilmn-alert-banner__buttons> <a data-ng-repeat=\"btn in vm.options.buttons\" class=btn data-ng-class=\"'btn-{{btn.buttonClass || 'default'}}'\" data-ng-href={{btn.link}} data-ng-attr-target=\"{{ btn.newTab && '_blank' }}\" data-ng-click=btn.action()>{{ btn.label }}</a> <button type=button class=\"close ilmn-alert-banner__close fa fa-close\" data-dismiss=alert aria-label=Close data-ng-if=options.dismissible data-ng-click=\"close({$event: $event})\"></button> </div> </div> ";
	window.angular.module('ilmn-ui-alert-banner').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 40 */
/*!*************************************************************!*\
  !*** ./ilmn-ui-alert-banner/scripts/alertBanner.service.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, __webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(require, angular, MODULE_NAME) {
	    'use strict';
	
	    angular.module(MODULE_NAME)
	        .service('$ilmnUiAlertBannerService', UiAlertBannerService);
	
	    UiAlertBannerService.$inject = ['$compile', '$rootScope'];
	    function UiAlertBannerService($compile, $rootScope) {
	        this.compile = $compile;
	        this.scope = $rootScope;
	        this.banners = [];
	        this.modalBannerCount = 0;
	    }
	
	    UiAlertBannerService.prototype.show = function(options) {
	        options = options || {};
	
	        var svc = this;
	        var parentEl = angular.element(options.prependTo || 'body');
	        var banner = angular.element('<ilmn-ui-alert-banner options="options"></ilmn-ui-alert-banner>');
	        var childScope = (options.scope || this.scope).$new();
	        var bannerIdx = this.banners.length;
	
	        angular.extend(childScope, {options: options, close: function() {
	            svc.closeBanner(bannerIdx, options);
	        }});
	
	        var el = this.compile( banner )(childScope);
	
	        if(options.overlay === true) {
	            this.modalBannerCount++;
	            this.showOverlay(parentEl);
	            this.disableAllEvents(el);
	        }
	
	        this.banners.push(el);
	        parentEl.prepend(el);
	
	        return childScope;
	    };
	
	    UiAlertBannerService.prototype.closeBanner = function(bannerIdx, bannerOptions) {
	        this.banners[bannerIdx].remove();
	
	        if(bannerOptions.overlay === true) {
	            this.modalBannerCount--;
	
	            if(this.modalBannerCount === 0) {
	                this.overlay.detach();
	            }
	        }
	        
	        if(typeof bannerOptions.onClose === 'function') {
	            bannerOptions.onClose();
	        }
	    };
	
	    UiAlertBannerService.prototype.clearBanners = function() {
	        this.banners.forEach(function(banner) {
	            banner.remove();
	        });
	        if(this.overlay) {
	            this.overlay.detach();
	        }
	    };
	
	    UiAlertBannerService.prototype.showOverlay = function(container) {
	        if(!this.overlay) {
	            this.overlay = angular.element('<div class="ilmn-alert-banner__overlay"></div>');
	            this.disableAllEvents(this.overlay);
	        }
	
	        container.prepend(this.overlay);
	    };
	
	    UiAlertBannerService.prototype.disableAllEvents = function(el) {
	        el.on("mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll", function(event) {
	            event.stopPropagation();
	        })
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 41 */
/*!******************************!*\
  !*** ./ilmn-ui-idle/main.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(/*! ./module */ 42),
	
	    __webpack_require__(/*! ./scripts/idle.service */ 44),
	    __webpack_require__(/*! ./scripts/idleMonitoring.service */ 45),
	    __webpack_require__(/*! ./scripts/sessionTracker.service */ 46)
	
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(module_name) {
	    return module_name;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 42 */
/*!********************************!*\
  !*** ./ilmn-ui-idle/module.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../ilmn-ui-utils/module */ 5), __webpack_require__(/*! ../ilmn-ui-alert-banner/module */ 37), __webpack_require__(/*! ng-idle */ 43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, ilmnUiUtils, ilmnUiAlertBanner) {
	    'use strict';
	
	    var MODULE_NAME = 'ilmn-ui-idle';
	
	    return angular
	        .module(MODULE_NAME, ['ngIdle', ilmnUiUtils, ilmnUiAlertBanner])
	        .config(['IdleProvider', 'KeepaliveProvider', '$httpProvider', '$ilmnUiSessionTrackerProvider', 'ilmnUiCookieUtilProvider', '$ilmnUiIdleServiceProvider', ModuleConfig])
	        .run(['$ilmnUiIdleService', '$ilmnUiIdleMonitoringService', '$log', ModuleRun])
	        .name;
	
	    function ModuleConfig($idleProvider, $keepaliveProvider, $httpProvider, $ilmnUiSessionTrackerProvider, ilmnUiCookieUtilProvider, $ilmnUiIdleServiceProvider) {
	        var psToken = ilmnUiCookieUtilProvider.get('psToken');
	        var idleTimeout = parseInt(ilmnUiCookieUtilProvider.get('idleTimeoutInSeconds')) || 0;
	
	        if(!psToken || idleTimeout <= 0) {
	            $ilmnUiIdleServiceProvider.disable(true);
	            return;
	        }
	
	        $idleProvider.idle(idleTimeout);
	        $idleProvider.timeout(30);
	        $idleProvider.interrupt('keydown mousedown');
	
	        var platformApi = ilmnUiCookieUtilProvider.get('psTokenIssuingAuthorities');
	        var pingInterval = ilmnUiCookieUtilProvider.get('idleTimeoutIntervalCheckInSeconds');
	        var platformId = (window.platformconfig)? window.platformconfig.clientId: undefined;
	
	        if(pingInterval && platformApi) {
	            platformApi = platformApi.replace(/"/g, '');
	
	            $ilmnUiSessionTrackerProvider.setPlatformBaseurl(platformApi);
	
	            var interceptor = ['$rootScope', '$q', function ($rootScope, $q) {
	                return {
	                    request: function (config) {
	                        if ((config.url.indexOf(platformApi) === 0) && (config.headers) && (!config.headers.Authorization)) {
	                            config.headers.Authorization = 'Bearer '+ psToken
	                        }
	                        return config;
	                    },
	                    response: function (response) {
	                        return response;
	                    },
	                    responseError: function (response) {
	                        if(response.status === 401) {
	                            $rootScope.$broadcast('$ilmnUiIdle.platformError');
	                        }
	                        // otherwise, default behaviour
	                        return $q.reject(response);
	                    }
	                }
	            }];
	            $httpProvider.interceptors.push(interceptor);
	
	            $keepaliveProvider.trackActivity(true);
	            $keepaliveProvider.interval(pingInterval);
	            $keepaliveProvider.http({
	                method: 'PUT',
	                url: platformApi + '/SessionTracker/?clientId=' + platformId
	            });
	        }
	
	    }
	
	    function ModuleRun($ilmnUiIdleService, $ilmnUiIdleMonitoringService, $log) {
	        if(!$ilmnUiIdleService.isDisabled()) {
	            $ilmnUiIdleMonitoringService.start();
	        } else {
	            $log.warn('ilmn-ui-idle: Activity monitoring is disabled.')
	        }
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 43 */
/*!**************************!*\
  !*** external "ng-idle" ***!
  \**************************/
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_43__;

/***/ }),
/* 44 */
/*!**********************************************!*\
  !*** ./ilmn-ui-idle/scripts/idle.service.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 42)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var SERVICE_NAME = '$ilmnUiIdleService';
	
	    angular.module(MODULE_NAME)
	        .provider(SERVICE_NAME, IlmnIdleServiceProvider);
	
	    function IlmnIdleServiceProvider() {
	        var state = {
	            disabled: false,
	            verbose: true
	        };
	
	        return {
	            disable: disable,
	            verboseLogs: verboseLogs,
	            $get: ['$log', '$rootScope', '$cookies', IlmnIdleService]
	        };
	
	        function disable(bool) {
	            state.disabled = bool === true;
	        }
	
	        function verboseLogs(bool) {
	            state.verbose = bool === true;
	        }
	
	        function IlmnIdleService($log, $rootScope, $cookies) {
	            var logoutFn;
	
	            return {
	                isDisabled: isDisabled,
	                setLogoutFn: setLogoutFn,
	                logout: logout,
	                log: log
	            };
	
	            function isDisabled() {
	                return state.disabled;
	            }
	
	            function setLogoutFn(fn) {
	                if(typeof fn != 'function') {
	                    throw TypeError("setLogoutFn expects argument 1 to ge a callable function.");
	                }
	
	                logoutFn = fn;
	            }
	
	            function logout() {
	                $cookies.remove("psToken", {domain: '.illumina.com', path: '/'});
	                $cookies.remove("psTokenIssuingAuthorities", {domain: '.illumina.com', path: '/'});
	                $rootScope.$broadcast('$ilmnUiIdle.userLogout');
	
	                if(logoutFn) {
	                    return logoutFn();
	                }
	            }
	
	            function log(msg) {
	                if(state.verbose) {
	                    $log.debug('ilmn-ui-idle: '+msg, new Date().toLocaleTimeString());
	                }
	            }
	        }
	    }
	
	
	    return SERVICE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 45 */
/*!********************************************************!*\
  !*** ./ilmn-ui-idle/scripts/idleMonitoring.service.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 42)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var SERVICE_NAME = '$ilmnUiIdleMonitoringService';
	
	    angular.module(MODULE_NAME)
	        .service(SERVICE_NAME, IlmnIdleMonitoringService);
	
	
	    IlmnIdleMonitoringService.$inject = ['$log', '$rootScope', 'Idle', 'Keepalive', '$ilmnUiIdleService', '$ilmnUiAlertBannerService', '$injector', '$ilmnUiSessionTracker'];
	    function IlmnIdleMonitoringService($log, $rootScope, $idle, $keepalive, $ilmnUiIdleService, $ilmnUiAlertBannerService, $injector, $ilmnUiSessionTracker) {
	        var alertBanner;
	
	        return {
	            start: start
	        };
	
	        function start() {
	            if($ilmnUiIdleService.isDisabled()) {
	                throw Error("ilmn-ui-idle: Idle service has been disabled");
	            }
	
	            $idle.watch();
	
	            $keepalive.ping(); //Send heartbeat on app startup
	
	            log('Watching user activity now', new Date().toLocaleTimeString());
	            log('idleTimeout: '+($idle.getIdle()/60)+'m idleTimeoutWarning: '+($idle.getTimeout()/60)+'m');
	
	            $rootScope.$on("IdleStart", onUserIdle);
	            $rootScope.$on('IdleEnd', onUserBack);
	            $rootScope.$on("IdleTimeout", onUserTimeout);
	            $rootScope.$on('$ilmnUiIdle.userLogout', onUserLoggedOut);
	            $rootScope.$on('$ilmnUiIdle.platformError', logout);
	
	            $rootScope.$on('Keepalive', function() {
	                log('KeepAlive Called');
	            });
	
	            $rootScope.$on('KeepaliveResponse', function(){
	                log('Keepalive Response')
	            })
	            $rootScope.$on('IdleInterrupt', function () {
	                log('Idle Interrupted (Timers will reset)');
	            });
	        }
	
	        function log(msg) {
	            $ilmnUiIdleService.log(msg);
	        }
	
	        function logout() {
	            $ilmnUiAlertBannerService.clearBanners();
	            $ilmnUiAlertBannerService.show({
	                message: 'For your safety, we automatically logged you out of your account after '+ ($idle.getIdle() / 60)+' minutes of inactivity. Sign in again to continue.',
	                type: 'success'
	            });
	            $ilmnUiIdleService.logout();
	        }
	
	        function onUserIdle() {
	            log("Hey, do something.. or I'll log you out (IdleStart)");
	
	            try {
	                var $uibModalStack = $injector.get('$uibModalStack');
	                $uibModalStack.dismissAll();
	            }
	            catch (e) {}
	
	            alertBanner = $ilmnUiAlertBannerService.show({
	                message: 'Are you still there? In order to keep your data safe, this session will end after ' + ($idle.getIdle() / 60) + ' minutes of inactivity.',
	                overlay: true,
	                buttons: [
	                    {
	                        label: 'Sign Out',
	                        action: function () {
	                            $log.debug('User clicked logout');
	                            alertBanner.close();
	                            $ilmnUiIdleService.logout();
	                            $idle.unwatch();
	                        }
	                    },
	                    {
	                        label: 'Stay Signed In',
	                        buttonClass: 'primary',
	                        action: function () {
	                            $idle.interrupt();
	                            alertBanner.close();
	                        }
	                    }
	                ]
	            });
	        }
	
	        function onUserBack() {
	            log('Phew, you are back.. I was about to log you out.');
	            alertBanner.close();
	        }
	
	        function onUserTimeout(){
	            $ilmnUiSessionTracker.isIdle().then(function(response) {
	                if(response && response.data && response.data.isIdle) {
	                    $log.error("ilmn-ui-idle: Hey, Sorry... we are logging you out due to inactivity");
	                    logout();
	                }
	                else {
	                    log('User not idle on other application');
	                    $idle.watch();
	                }
	            });
	        }
	
	        function onUserLoggedOut() {
	            $idle.unwatch();
	            $keepalive.stop();
	        }
	    }
	
	    return SERVICE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 46 */
/*!********************************************************!*\
  !*** ./ilmn-ui-idle/scripts/sessionTracker.service.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! angular */ 2), __webpack_require__(/*! ../module */ 42)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular, MODULE_NAME) {
	    'use strict';
	
	    var SERVICE_NAME = '$ilmnUiSessionTracker';
	
	    angular.module(MODULE_NAME)
	        .provider(SERVICE_NAME, SessionTracker);
	
	    function SessionTracker() {
	        var platformApiBaseurl;
	
	        service.$inject = ['$log', '$http'];
	        return {
	            setPlatformBaseurl: setPlatformBaseurl,
	            $get: service
	        };
	
	        function service($log, $http) {
	            return {
	                isIdle: isIdle
	            };
	
	            function isIdle() {
	                var url = platformApiBaseurl + '/SessionTracker/IsIdle';
	                return $http.get(url);
	            }
	        }
	
	        function setPlatformBaseurl(baseurl) {
	            platformApiBaseurl = baseurl;
	        }
	    }
	
	    return SERVICE_NAME;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// ilmn-ui-components.min.js